/**
 * @generated SignedSource<<877f3fd00689386bf1a3a7a6f9535bd1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useMembershipsRelayByIdQuery$variables = {
  id: string;
};
export type useMembershipsRelayByIdQuery$data = {
  readonly getMembership: {
    readonly activeOn: any | null | undefined;
    readonly archivedOn: any | null | undefined;
    readonly authExpiration: string | null | undefined;
    readonly authType: string | null | undefined;
    readonly brandingColor: string;
    readonly createdOn: any;
    readonly creditCardHold: number | null | undefined;
    readonly data: any | null | undefined;
    readonly hidden: boolean | null | undefined;
    readonly hideValidEmails: boolean | null | undefined;
    readonly id: string;
    readonly logoImageId: string | null | undefined;
    readonly maxRentals: number | null | undefined;
    readonly minimumWalletDeposit: number | null | undefined;
    readonly monthlyCost: number | null | undefined;
    readonly name: string;
    readonly oldId: string | null | undefined;
    readonly organizationId: string | null | undefined;
    readonly password: string | null | undefined;
    readonly perks: ReadonlyArray<{
      readonly activeOn: any | null | undefined;
      readonly archivedOn: any | null | undefined;
      readonly createdOn: any;
      readonly discount: number | null | undefined;
      readonly freeTime: number | null | undefined;
      readonly id: string;
      readonly location: {
        readonly id: string;
        readonly name: string;
        readonly oldId: string | null | undefined;
      } | null | undefined;
      readonly locationId: string | null | undefined;
      readonly moneyOff: number | null | undefined;
      readonly noFlex: boolean | null | undefined;
      readonly oldId: string | null | undefined;
      readonly reservation: boolean | null | undefined;
      readonly system: {
        readonly currencyCode: string | null | undefined;
        readonly id: string;
        readonly mobilityType: number | null | undefined;
        readonly name: string | null | undefined;
        readonly oldId: string | null | undefined;
      } | null | undefined;
      readonly systemOldId: string | null | undefined;
      readonly waiveBaseRate: boolean | null | undefined;
    }>;
    readonly prices: ReadonlyArray<{
      readonly activeOn: any;
      readonly archivedOn: any | null | undefined;
      readonly autoRenews: boolean;
      readonly createdOn: any;
      readonly id: string;
      readonly minutes: number | null | undefined;
      readonly name: string | null | undefined;
      readonly price: number | null | undefined;
      readonly priority: number;
      readonly renewalInterval: string | null | undefined;
      readonly termEndsOn: any | null | undefined;
      readonly termStartsOn: any | null | undefined;
      readonly unlocks: number | null | undefined;
    }>;
    readonly priority: number;
    readonly replacementMembership: {
      readonly id: string;
      readonly name: string;
      readonly oldId: string | null | undefined;
    } | null | undefined;
    readonly system: {
      readonly currencyCode: string | null | undefined;
      readonly id: string;
      readonly mobilityType: number | null | undefined;
      readonly name: string | null | undefined;
      readonly oldId: string | null | undefined;
    } | null | undefined;
    readonly systemId: string | null | undefined;
    readonly systemOldId: string | null | undefined;
    readonly validEmails: ReadonlyArray<string> | null | undefined;
    readonly yearlyCost: number | null | undefined;
  } | null | undefined;
};
export type useMembershipsRelayByIdQuery = {
  response: useMembershipsRelayByIdQuery$data;
  variables: useMembershipsRelayByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oldId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdOn",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activeOn",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archivedOn",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priority",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "systemOldId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "System",
  "kind": "LinkedField",
  "name": "system",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currencyCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mobilityType",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/)
],
v11 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Membership",
    "kind": "LinkedField",
    "name": "getMembership",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "authType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "authExpiration",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "password",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "validEmails",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hideValidEmails",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "creditCardHold",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "minimumWalletDeposit",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "monthlyCost",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "yearlyCost",
        "storageKey": null
      },
      (v7/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxRentals",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hidden",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "brandingColor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "logoImageId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "systemId",
        "storageKey": null
      },
      (v8/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizationId",
        "storageKey": null
      },
      (v9/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Membership",
        "kind": "LinkedField",
        "name": "replacementMembership",
        "plural": false,
        "selections": (v10/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Perk",
        "kind": "LinkedField",
        "name": "perks",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "freeTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "discount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "moneyOff",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "waiveBaseRate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "noFlex",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reservation",
            "storageKey": null
          },
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "locationId",
            "storageKey": null
          },
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Location",
            "kind": "LinkedField",
            "name": "location",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MembershipPrice",
        "kind": "LinkedField",
        "name": "prices",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "price",
            "storageKey": null
          },
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "autoRenews",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "renewalInterval",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "termStartsOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "termEndsOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minutes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unlocks",
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useMembershipsRelayByIdQuery",
    "selections": (v11/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMembershipsRelayByIdQuery",
    "selections": (v11/*: any*/)
  },
  "params": {
    "cacheID": "b1ddcb870140c9ec891e7fad4b3f6599",
    "id": null,
    "metadata": {},
    "name": "useMembershipsRelayByIdQuery",
    "operationKind": "query",
    "text": "query useMembershipsRelayByIdQuery(\n  $id: ID!\n) {\n  getMembership(id: $id) {\n    id\n    oldId\n    name\n    createdOn\n    activeOn\n    archivedOn\n    authType\n    authExpiration\n    password\n    validEmails\n    hideValidEmails\n    creditCardHold\n    minimumWalletDeposit\n    monthlyCost\n    yearlyCost\n    priority\n    maxRentals\n    hidden\n    brandingColor\n    logoImageId\n    data\n    systemId\n    systemOldId\n    organizationId\n    system {\n      id\n      oldId\n      name\n      currencyCode\n      mobilityType\n    }\n    replacementMembership {\n      id\n      oldId\n      name\n    }\n    perks {\n      id\n      oldId\n      createdOn\n      activeOn\n      archivedOn\n      freeTime\n      discount\n      moneyOff\n      waiveBaseRate\n      noFlex\n      reservation\n      systemOldId\n      locationId\n      system {\n        id\n        oldId\n        name\n        currencyCode\n        mobilityType\n      }\n      location {\n        id\n        oldId\n        name\n      }\n    }\n    prices {\n      id\n      createdOn\n      activeOn\n      archivedOn\n      price\n      priority\n      autoRenews\n      renewalInterval\n      termStartsOn\n      termEndsOn\n      minutes\n      unlocks\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d0f98eb198edde3e54607941755a070b";

export default node;
